










import { Vue, Component, Prop } from 'vue-property-decorator';
import { TabClassName } from '@/types';
import { TabMenuInfo } from '@/types/promotion';
import { TAB_CLASS_NAME } from '@/const/common';


@Component
export default class TabMenu<menuType> extends Vue {
  @Prop({ required: true })
  readonly tabMenus: TabMenuInfo<menuType>[];
  
  @Prop({ required: true })
  readonly currentTab: menuType;
  
  @Prop({ default: TAB_CLASS_NAME.MD })
  readonly tabClassName: TabClassName;
  
  private handleClick(currentTabType: menuType) {
    this.$emit('handle-click-tab', currentTabType);
  }
}
